import snappPayLogo from "@website/accommodation-ui/hotel-snapp-pay/assets/snapp_pay_logo.png";
import { SnappPayDetailsModal } from "@website/accommodation-ui/hotel-snapp-pay/components/SnappPayDetailsModal";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { LazyImage } from "@website/ui/lazy-image";
import { FC, memo, useState } from "react";

const Component: FC = () => {
  const [open, isOpen] = useState(false);

  const toggleModal = () => {
    isOpen((previous) => !previous);
  };

  return (
    <>
      <div className="px-6 lg:px-0">
        <div
          className="flex w-full flex-col items-start rounded-lg p-2 md:flex-row md:items-center md:justify-between md:p-3"
          style={{
            background: "linear-gradient(90deg, #148EEB 0%, #76B4FD 100%)"
          }}
        >
          <div className="flex flex-row items-center gap-2">
            <LazyImage
              fetchPriority="high"
              height={48}
              src={snappPayLogo.src}
              width={48}
            />
            <div className="flex flex-col gap-1 text-white">
              <p className="text-sm font-semibold">
                امکان رزرو ۴قسطه بدون ضامن، چک و سفته
              </p>
              <span className="text-xs font-light">
                با انتخاب درگاه اسنپ‌پی هنگام پرداخت
              </span>
            </div>
          </div>
          <div className="pr-11 md:pr-0">
            <Button
              EndIcon={<MaterialIcon name="chevron_left" />}
              className="!font-light !text-white"
              onClick={toggleModal}
              size="small"
              type="button"
              variant="text"
            >
              جزییات بیشتر
            </Button>
          </div>
        </div>
      </div>
      <SnappPayDetailsModal onClose={toggleModal} open={open} />
    </>
  );
};

export const HotelSnappPayDraft = memo(Component);
